import React from "react";

const WorkReferencesContainer = ({ children }) => (
  <div className="col-md-10 offset-md-1 mb-3">{children}</div>
);
export default WorkReferencesContainer;
